module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 119.93ce4bf6.png";